<template>
    <div class="agenda column" v-if="job && job.tipo == 'alocacao'">
        <Button layout="gray" @click="modal.show = true">
            <i class="fa fa-calendar" /> Agenda
        </Button>
        <Modal :modal="modal">
            <div class="info row">
                <div class="grid-3 grid-12-s column"><label>Cliente</label>{{ job.nome_cliente }}</div>
                <div class="grid-3 grid-12-s column"><label>Forma atendimento</label>{{ job.forma_atendimento }}</div>
                <div class="grid-3 grid-12-s column"><label>Supporter</label>{{ job.nome_doutor }}</div>
                <div class="grid-3 grid-12-s column"><label>Total Reg.</label>{{ list.length }}</div>
            </div>
            <div class="row head">
                <div class="grid-2">ID</div>
                <div class="grid-2">Atendimento</div>
                <div class="grid-3">Supporter</div>
                <div class="grid-2">Início Atendimento</div>
                <div class="grid-2">Fim Atendimento</div>
                <div class="grid-2">Status</div>
                <div class="grid-2">Criado em</div>
                <div class="grid-2">Alterado em</div>
                <div class="grid-1">Cancelar</div>
            </div>
            <div class="content">
                <div v-for="j of list" class="line row" :key="j.id">
                    <div class="grid-2 column">{{ j.id }}</div>
                    <div class="grid-2 column">{{ j.id_atendimento }}</div>
                    <div class="grid-3 column">{{ j.nome_doutor }}</div>
                    <div class="grid-2 column">{{ j.dh_atendimento | date }}</div>
                    <div class="grid-2 column">{{ j.dh_encerramento | date }}</div>
                    <div class="grid-2 column">{{ j.status }}</div>
                    <div class="grid-2 column">{{ j.criado_em | date }}</div>
                    <div class="grid-2 column">{{ j.alterado_em | date }}</div>
                    <div class="grid-1 column align-center"><i @click="openCancel(j.id)" v-if="j.status == 'agendado'"
                            class="fa fa-trash pointer" title="CANCELAR" /></div>
                </div>
            </div>
        </Modal>
        <Modal :modal="modalc">
            <div class="form row align-end justify-space">
                <div class="grid-2 column">
                    <label>Repõe Agendamento</label>
                    <select v-model="form.repoe_agendamento">
                        <option value="">SELECIONE</option>
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                    </select>
                </div>
                <div class="grid-6 column">
                    <label>Motivo do Cancelamento</label>
                    <input v-model="form.motivo_cancelamento" placeholder="Motivo cancelamento" />
                </div>
                <Button @click="cancel" layout="green-go" :loader="loader">Cancelar agendamento</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";

export default {
    name: "Agenda",
    props: { job: Object },
    components: { Button, Modal },
    data() {
        return {
            loader: false,
            form: { id: this.job.id, agendamentos: [], repoe_agendamento: '' },
            ID: false,
            list: [],
            modal: {
                title: 'Agenda Job ' + this.job.id,
                show: false,
            },
            modalc: {
                title: 'Cancela Agendamento ' + this.job.id,
                show: false,
            }
        }
    },
    methods: {
        ...mapActions("job", ["AGENDA", "CANCELA_AGENDA"]),
        load() {
            if (this.job.id)
                this.AGENDA(this.job.id).then(({ data }) => this.list = data || [])
        },
        async openCancel(ID) {
            this.form.agendamentos = [ID]
            this.modal.show = false
            this.modalc = {
                title: `Cancela agendamento ${ID} - Job ${this.job.id}`,
                show: true,
                callback: () => this.modal.show = true
            }
        },
        async cancel() {
            this.loader = true
            await this.CANCELA_AGENDA(this.form)
            this.loader = false
            this.modal.show = true
            this.modalc.show = false
            this.load()
        }
    },
    mounted() {
        this.load()
    }
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.agenda
    button
        margin-left: 12px
        margin-bottom: 12px
    .load
        margin-left: -18px
        font-size: 18px
        &:hover
            color: $purple
            font-size: 22px       
    .modal-box
        padding: 33px
        
        @media (min-width: $small)
            min-width: 1200px
        .info
            margin: 0 12px
            padding: 0 22px
            padding-bottom: 22px
            border-bottom: 1px inset #eee
        .content
            padding-bottom: 22px
            height: 600px
            overflow: auto
        .head
            color: $purple
            margin: 0 30px
            margin-top: 22px
            padding: 8px
            font-size: 14px
        .line
            margin: 0 30px
            padding: 8px
            color: $font-color
            font-size: 15px 
            &:nth-child(even)
                background: #eee
            i:hover
                color: $red
        label
            @include label
            margin-top: 12px
        .form
            padding: 30px
</style>